<template>
  <div class="business-progress" data-title="申请流程">
    <!-- 进程 -->
    <applyPartner>
      <template v-slot:top>
        <p class="title">
          申请商家
        </p>
      </template>
      <template v-slot:left>
        <dl class="contract">
          <dt>
            <img src="../../assets/images/partner-img/5.png" alt="">
          </dt>
          <dd>
            签约合同
          </dd>
        </dl>
      </template>
      <template v-slot:right>
        <dl class="prove">
          <dt>
            <img src="../../assets/images/partner-img/9.png" alt="">
          </dt>
          <dd>
            完成认证
          </dd>
        </dl>
      </template>
    </applyPartner>
    <!-- 提示 -->
    <div class="hint">
      <img src="../../assets/images/partner-img/10.png" alt="">
      <p>
        您的认证资料已提交完成，将于<span>24小时</span>内完成审核！审核过程中平台有可能与你联系请耐心等待；                
      </p>
    </div>
    <!-- 查看详情 -->
    <div class="particulars">
      <div class="div1">
        <img src="../../assets/images/partner-img/11.png" alt="">
      </div>
      <div class="div2" @click="details_btn">
        <img src="../../assets/images/partner-img/12.png" alt="">
      </div>
      <contactWay></contactWay>
    </div>

  </div>
</template>

<script> 

import applyPartner from '../../components/partner/apply-partner'
import contactWay from '../../components/partner/contact-way'

export default {
  data(){
    return{
      
    }
  },
  components:{
    applyPartner,
    contactWay
  },
  methods:{
    details_btn(){
      this.$router.push('/schedule-details')
    }
  }
}
</script>

<style lang="less" scoped>
  .business-progress{
    width: 7.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
    // 提示
    .hint{
      width: 7.1rem;
      height: 1rem;
      background: #fff;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      display: flex;
      img{
        width: .61rem;
        height: .61rem;
        margin: .19rem .1rem 0 .2rem;
      }
      p{
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #A7A7A7;
        width: 5.59rem;
        line-height: .3rem;
        letter-spacing : .01rem;
        margin-top: .2rem;
        span{
          color: #FF6702;
        }
      }
    }
    .particulars{
      width: 7.1rem;
      height: 7.64rem;
      margin: 0 auto;
      border-radius: .1rem;
      margin-top: .1rem;
      background: #fff;
      text-align: center;
      .div1{
        width: 3.03rem;
        height: 2.69rem;
        margin: 0 auto;
        margin-top: 1.07rem;
        img{
          width: 3.03rem;
          height: 2.69rem;
        }
      }
      .div2{
        width: 2.42rem;
        height: .72rem;
        margin: 0 auto;
        margin-bottom: 1.98rem;
        img{
          width: 2.42rem;
          height: .72rem;
          margin-top: .57rem;
        }
      }
    }

  }
</style>

